import type { FC } from 'react';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container } from '@mui/material';
import ContentHeader, { Crumb } from 'components/ContentHeader';
import useSettings from 'hooks/useSettings';
import gtm from 'lib/gtm';
import Paper from '@mui/material/Paper';
import { appSettings } from '../../config';

type Props = {
  title: string
  crumbs?: Crumb[]
  buttons?: any[]
  summary?: React.ReactNode
};

const ListViewLayout: FC<React.PropsWithChildren<Props>> = ({ title, crumbs, buttons, summary, children }) => {
  const { settings } = useSettings();

  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {`${title} | ${appSettings.appName}`}
        </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 8
        }}
      >
        <Container maxWidth={settings.compact ? 'xl' : false}>
          <ContentHeader
            title={title}
            crumbs={crumbs}
            buttons={buttons}
          />
          {summary}
          <Paper sx={{ mt: 2 }}>
            {children}
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default ListViewLayout;
